import { Col, Container, Row } from 'react-bootstrap';
import { AiOutlineEdit } from 'react-icons/ai';
import { BsTrash } from 'react-icons/bs';
import { FaNetworkWired } from 'react-icons/fa';
import PropTypes from 'prop-types';
import IconButton from '../../util/IconButton';

function ExistingPolicies({ policies, onEdit, onRemove, useTestIds = true }) {
  const trustColor = 'rgb(40, 167, 69)';
  const untrustedColor = 'rgb(220, 53, 69)';
  const disabledColor = 'rgba(0, 0, 0, 0.2)';

  if (policies.length === 0) {
    return (
      <tr>
        <td style={{ color: 'grey' }}>No Policies Specified</td>
      </tr>
    );
  }

  return policies
    .sort((dev1, dev2) => {
      const name1 = dev1.name.toLowerCase();
      const name2 = dev2.name.toLowerCase();

      if (name1 < name2) return -1;
      if (name1 > name2) return 1;
      return 0;
    })
    .map((policy) => {
      let color;
      if (!policy.enabled) {
        color = disabledColor;
      } else if (policy.trusted) {
        color = trustColor;
      } else {
        color = untrustedColor;
      }

      return (
        <tr
          style={
            !policy.enabled
              ? {
                  backgroundColor: 'rgba(0, 0, 0, 0.1)',
                  color: 'gray',
                  fontStyle: 'italic',
                }
              : {}
          }
          key={policy.name}
        >
          <td>
            <FaNetworkWired size="2em" color={color} />
            <br />
            {policy.name}
          </td>
          <td>{policy.trusted ? 'Trusted' : 'Not Trusted'}</td>
          <td>
            {policy.ipAddressOrRangeNotation
              .replace('-', ' - ')
              .replace('/', ' / ')}
          </td>
          <td>{policy.enabled ? 'Enabled' : 'Disabled'}</td>
          <td>
            <Container style={{ padding: 0, float: 'right' }}>
              <Row>
                <Col>
                  <IconButton
                    name={`edit-${policy.name}`}
                    icon={<AiOutlineEdit />}
                    tooltip="Edit"
                    title={`Edit ${policy.name}`}
                    onClick={() => onEdit(policy)}
                    variant="outline-secondary"
                    style={{ float: 'right', marginBottom: '.15em' }}
                    useTestIds={useTestIds}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <IconButton
                    name={`delete-${policy.name}`}
                    icon={<BsTrash />}
                    tooltip="Delete"
                    title={`Delete ${policy.name}`}
                    onClick={() => onRemove(policy.name)}
                    variant="outline-secondary"
                    style={{ float: 'right' }}
                    useTestIds={useTestIds}
                  />
                </Col>
              </Row>
            </Container>
          </td>
        </tr>
      );
    });
}

ExistingPolicies.propTypes = {
  policies: PropTypes.array,
  onEdit: PropTypes.func,
  onRemove: PropTypes.func,
  useTestIds: PropTypes.bool,
};

export default ExistingPolicies;
